module.exports = __webpack_public_path__ + "static/media/map-marker-times.dffe190c.svg";